import { createUseStyles } from 'react-jss';

const getNumberOfGapItem = (numberOfVisibleItems) => (Math.floor(numberOfVisibleItems / 2));

const useStyle = createUseStyles((theme) => ({
  wheelChoose: (props) => ({
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
    fontFamily: 'inherit',
    userSelect: 'none',
    position: 'relative',
    height: `${props.itemHeight * props.numberOfVisibleItems}px`,
    '& > .inner': {
      height: 'auto',
      transition: `transform ${theme.speed.normal}ms ease-out`,
    },
    '& > .selected-border': {
      position: 'absolute',
      width: '100%',
      height: `${props.itemHeight + 10}px`,
      top: `${(props.itemHeight * getNumberOfGapItem(props.numberOfVisibleItems)) - props.numberOfVisibleItems}px`,
      left: 0,
      borderTop: `solid 1px ${theme.colors[props.color].normal}`,
      borderBottom: `solid 1px ${theme.colors[props.color].normal}`,
      pointerEvents: 'none',
      backgroundColor: 'transparent',
    },
    '& > .top-shadow, & > .bottom-shadow': {
      position: 'absolute',
      height: `${props.itemHeight + 20}px`,
      width: '100%',
      left: 0,
      pointerEvents: 'none',
      '&.top-shadow': {
        top: 0,
        boxShadow: `inset 0 30px 20px ${theme.colors.background.normal}`,
        backgroundColor: 'transparent',
      },
      '&.bottom-shadow': {
        bottom: 0,
        boxShadow: `inset 0 -30px 20px ${theme.colors.background.normal}`,
        backgroundColor: 'transparent',
      },
    },
  }),
}));

export default useStyle;
